var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardBonus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.641 1.17l6.73 3.869c.39.224.629.635.629 1.077v7.768c0 .442-.24.852-.629 1.076l-6.73 3.87a1.29 1.29 0 01-1.282 0l-6.73-3.87A1.243 1.243 0 011 13.884v-7.77c0-.441.24-.851.629-1.075l6.73-3.868a1.289 1.289 0 011.282 0z",
    fill: "url(#reward_bonus_svg__a)",
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.685 8.325a.179.179 0 00-.128-.048h-.956a1.804 1.804 0 00-.358-.768h1.303a.179.179 0 00.128-.048.163.163 0 00.05-.123v-.542a.163.163 0 00-.05-.124.18.18 0 00-.128-.047H6.893a.179.179 0 00-.129.048.162.162 0 00-.05.123v.709c0 .045.018.085.054.12.034.033.077.05.125.05h.812c.786 0 1.286.201 1.497.603H6.895a.179.179 0 00-.13.048.162.162 0 00-.05.122v.544c0 .05.017.09.05.123a.182.182 0 00.13.047h2.388a1.054 1.054 0 01-.574.667c-.3.153-.697.228-1.188.228h-.626a.176.176 0 00-.126.051.16.16 0 00-.054.12v.678c0 .044.018.086.05.117.717.725 1.645 1.739 2.786 3.044.034.043.08.064.139.064h1.09c.08 0 .133-.033.163-.097.037-.064.03-.123-.023-.18-1.088-1.273-1.943-2.225-2.566-2.857.634-.072 1.149-.268 1.543-.587a1.97 1.97 0 00.722-1.248h.94a.179.179 0 00.128-.047.162.162 0 00.05-.124v-.542a.162.162 0 00-.05-.124h-.002z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "reward_bonus_svg__a",
    x1: 0.088,
    y1: -16.024,
    x2: -24.461,
    y2: 18.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAD3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B244D2"
  })))));
}
export default SvgRewardBonus;